import { Money } from '@cash-web/protos/squareup/common/currency.pb'
import { CurrencyCode } from '@cash-web/protos/squareup/common/currency_codes.pb'

export type ValidMoney = {
  amount: number
  currency_code: CurrencyCode
}

export function isValidMoney(money?: Money): money is ValidMoney {
  return !!money && money.amount !== undefined && money.currency_code !== undefined
}
